import React, {useContext, useEffect, useRef, useState} from 'react';
import {useFormik} from "formik";
import {InputText} from "primereact/inputtext";
import {Password} from "primereact/password";
import {Button} from "primereact/button";
import {AuthContext} from "../App";
import {Messages} from "primereact/messages";
import {UserService} from "../services/UserService";


export default function Login ({onLogin}) {
    const [formData, setFormData] = useState({});
    const loginErrorMessage = useRef(null);
    const auth = useContext(AuthContext)
    const userservice = new UserService();

    // useEffect(() =>
    //     {
    //         if(formData.username && formData.password){
    //             userservice.loginUser(formData).then(resp => {
    //                 if(resp?.status === 200) {
    //                     resp.json().then(token => {
    //                         handleLoginResponse({user: null, token: token});
    //                     })
    //                 } else {
    //                     loginNotSuccessful()
    //                 }
    //             }, token => {
    //                 showPromiseError()
    //             }).finally(() => {
    //                 auth?.isAuthenticated();
    //             })
    //         }
    //         return () => {
    //             // clean up
    //         };
    //     }, [formData]);
    //
    //     const showPromiseError =() => {
    //         loginErrorMessage.current.show({severity: 'error', detail: 'Promise not fulfilled', sticky: true})
    //     }
    //


    const handleLoginResponse = (loginResponse) => {
        if(onLogin(loginResponse)){
            formik.resetForm();
        } else {
            loginErrorMessage.current.show({severity: 'error', detail: 'Invalid username or password.', sticky: true});
        }
    }

    const formik = useFormik({
        initialValues: {
            username: '',
            password: '',
        },
        validate: (data) => {
            let errors = {};

            if (!data.username) {
                errors.username = 'Name is required.';
            }

            if (!data.password) {
                errors.password = 'Password is required.';
            }

            return errors;
        },
        onSubmit: (data) => {
            if (data.username.length < 3 || !/^\S*$/.test(data.username) || data.password.length < 8) {
                loginErrorMessage.current.show({severity: 'error', detail: 'Invalid username or password', sticky: true});
                handleLoginResponse(null);
            } else {
                //setFormData(data)
                userservice.loginUser(data).then(resp => {
                    if(resp?.status === 200) {
                        resp.json().then(token => {
                            handleLoginResponse({user: null, token: token});
                        })
                    } else {
                        handleLoginResponse({user: null, token: null});
                    }
                }, token => {

                }).finally(() => {
                })
            }
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <div className="flex justify-content-center">
            <div className="card">
                <form onSubmit={formik.handleSubmit} className="p-fluid">
                    <div className="field">
                        <span className="p-float-label">
                            <InputText id="username" name="username" value={formik.values.username} onChange={formik.handleChange} autoFocus />
                            <label htmlFor="username">Username</label>
                        </span>
                        {getFormErrorMessage('username')}
                    </div>
                    <div className="field">
                        <span className="p-float-label">
                            <Password id="password2" name="password" value={formik.values.password} onChange={formik.handleChange} toggleMask feedback={false}/>
                            <label htmlFor="password2">Password</label>
                        </span>
                        {getFormErrorMessage('password')}
                    </div>

                    <Button type="submit" label="Login" className="mt-2" />
                </form>

                <Messages ref={loginErrorMessage} />
            </div>
        </div>
    );
}